module.exports = __webpack_public_path__ + "static/media/aboutus.e8d0d930.jpg";